module.exports = __webpack_public_path__ + "static/media/7.ecb1e245.jpg";